import { createContext , useContext , useEffect, useState , ReactNode} from "react";

interface ThemeContextType {
    theme: string;
    toggleTheme: () => void;
  }

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
      throw new Error("useTheme must be used within a ThemeProvider");
    }
    return context; 
  }

interface ThemeProviderProps {
    children: ReactNode; 
  }

export const ThemeProvider = ({ children } : ThemeProviderProps) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleTheme = () => { 
        setIsDarkMode(!isDarkMode);
    }

    useEffect(() => {
        if(isDarkMode) {
            document.documentElement.classList.add("dark");
        }
        else {
            document.documentElement.classList.remove("dark");
        }
    }, [isDarkMode]);

    const theme = isDarkMode ? "dark" : "light";

  return (
    <ThemeContext.Provider value={{theme , toggleTheme}}>
      {children}
    </ThemeContext.Provider>
  );
}

